import { useState } from "react";
import { Trash2, Power } from "lucide-react";
import { toast } from "sonner";
import { money } from "../../lib/api";
import { PromoInsights } from "./PromoInsights";

export const PromotionsTab = ({ promos, insights, onCreate, onToggle, onDelete }) => {
  const [form, setForm] = useState({ code: "", percent_off: 0, flat_off: 0, max_uses: 100, note: "" });
  const [view, setView] = useState("Codes");

  const submit = async (e) => {
    e.preventDefault();
    try {
      await onCreate({
        ...form,
        percent_off: Number(form.percent_off) || 0,
        flat_off: Number(form.flat_off) || 0,
        max_uses: Number(form.max_uses) || 1,
        active: true,
      });
      toast.success("Promotional code created");
      setForm({ code: "", percent_off: 0, flat_off: 0, max_uses: 100, note: "" });
    } catch (error) {
      toast.error(error.response?.data?.detail || "Could not create code");
    }
  };

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="mt-12" data-testid="admin-promos">
      <div className="flex gap-2">
        {["Codes", "Insights"].map((v) => (
          <button key={v} onClick={() => setView(v)} data-testid={`promo-view-${v.toLowerCase()}`}
            className={`px-5 py-2.5 text-[0.65rem] uppercase tracking-widest border transition-colors ${view === v ? "border-amber-400 text-amber-200 bg-amber-500/10" : "border-amber-500/20 text-slate-400 hover:border-amber-500/45"}`}>
            {v}
          </button>
        ))}
      </div>

      {view === "Insights" ? (
        <div className="mt-8"><PromoInsights insights={insights} /></div>
      ) : (
      <div className="grid lg:grid-cols-3 gap-8 mt-8">
      <form onSubmit={submit} className="hy-card p-7 space-y-5 h-fit" data-testid="promo-form">
        <div className="hy-label">New promotional code</div>
        <input required value={form.code} onChange={set("code")} className="hy-input" placeholder="CODE" data-testid="promo-code-input" />
        <div className="grid grid-cols-2 gap-3">
          <label className="block">
            <span className="hy-label text-[0.55rem]">Percent off</span>
            <input type="number" min="0" max="90" value={form.percent_off} onChange={set("percent_off")}
              className="hy-input mt-2" placeholder="10" data-testid="promo-percent-input" />
          </label>
          <label className="block">
            <span className="hy-label text-[0.55rem]">Flat ₹ off</span>
            <input type="number" min="0" value={form.flat_off} onChange={set("flat_off")}
              className="hy-input mt-2" placeholder="500" data-testid="promo-flat-input" />
          </label>
        </div>
        <label className="block">
          <span className="hy-label text-[0.55rem]">Maximum redemptions</span>
          <input type="number" min="1" value={form.max_uses} onChange={set("max_uses")}
            className="hy-input mt-2" placeholder="100" data-testid="promo-uses-input" />
        </label>
        <label className="block">
          <span className="hy-label text-[0.55rem]">Internal note</span>
          <input value={form.note} onChange={set("note")} className="hy-input mt-2"
            placeholder="Launch offer" data-testid="promo-note-input" />
        </label>
        <button className="hy-btn w-full py-3.5 text-xs uppercase" data-testid="promo-create-btn">Create code</button>
      </form>

      <div className="lg:col-span-2 space-y-4">
        {promos.map((p) => (
          <div key={p.code} className="hy-card p-6 flex flex-wrap items-center justify-between gap-4" data-testid={`promo-${p.code}`}>
            <div>
              <div className="font-mono-hy text-amber-200">{p.code}</div>
              <div className="text-xs text-slate-500 mt-1">
                {p.percent_off > 0 && `${p.percent_off}% off `}{p.flat_off > 0 && `${money(p.flat_off)} off `}
                · {p.used_count}/{p.max_uses} used {p.note && `· ${p.note}`}
              </div>
            </div>
            <div className="flex items-center gap-4">
              <span className={`text-[0.6rem] uppercase tracking-widest ${p.active ? "text-emerald-400" : "text-slate-500"}`}>
                {p.active ? "Active" : "Disabled"}
              </span>
              <button onClick={() => onToggle(p.code)} className="text-slate-400 hover:text-amber-300" data-testid={`promo-toggle-${p.code}`}>
                <Power className="w-4 h-4" />
              </button>
              <button onClick={() => onDelete(p.code)} className="text-slate-400 hover:text-red-400" data-testid={`promo-delete-${p.code}`}>
                <Trash2 className="w-4 h-4" />
              </button>
            </div>
          </div>
        ))}
      </div>
      </div>
      )}
    </div>
  );
};
